import commonExtend from '../common/extend';
export default [...commonExtend

// Forum-only extenders go here
];